import { render, staticRenderFns } from "./ScoreHeader.vue?vue&type=template&id=ab4cbd0c&scoped=true&"
import script from "./ScoreHeader.vue?vue&type=script&lang=js&"
export * from "./ScoreHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab4cbd0c",
  null
  
)

export default component.exports